import styled from 'styled-components';
import ReadMoreCard from './ReadMoreCard';

const ReadMoreCardListStyled = styled.div`
  .readmore-card-list {
    display: flex;
    padding: 0;
    margin-block: 6.4rem;
  }

  .readmore-card {
    margin-bottom: 1.6rem;

    @include mobile-only {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;

const ReadMoreCardList = ({ items }) => (
  <ReadMoreCardListStyled>
    <ul className="readmore-card-list non-bdo-style-list row">
      {items.map((item) => (
        <li key={items.indexOf(item)} className="readmore-card col-md-6 col-lg-3">
          <ReadMoreCard {...item} />
        </li>
      ))}
    </ul>
  </ReadMoreCardListStyled>
);

export default ReadMoreCardList;
